import fetchAllCampusesById from "./fetchAllCampusesById";

const fetchAllCampuses = async () => {
	const campusesById = await fetchAllCampusesById();
	return Object.values(campusesById);
};

export default fetchAllCampuses;
